/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiUserFeedbackControllerUpdateMutationResponse, AiUserFeedbackControllerUpdatePathParams, AiUserFeedbackControllerUpdate400, AiUserFeedbackControllerUpdate401, AiUserFeedbackControllerUpdate404 } from "../../models/aiUserFeedbackController/AiUserFeedbackControllerUpdate";

function getAiUserFeedbackControllerUpdateUrl(id: AiUserFeedbackControllerUpdatePathParams["id"]) {
  const res = { method: 'PUT', url: `/api/v1/ai-user-feedback/${id}` as const }  
  return res
}

/**
 * @summary Update feedback
 * {@link /api/v1/ai-user-feedback/:id}
 */
export async function aiUserFeedbackControllerUpdate(id: AiUserFeedbackControllerUpdatePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiUserFeedbackControllerUpdateMutationResponse, ResponseErrorConfig<AiUserFeedbackControllerUpdate400 | AiUserFeedbackControllerUpdate401 | AiUserFeedbackControllerUpdate404>, unknown>({ method : "PUT", url : getAiUserFeedbackControllerUpdateUrl(id).url.toString(), ... requestConfig })  
  return res.data
}